import React from "react";
import BannerInputs from "../../../components/Banner/BannerInputs";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";
import { useNavigate } from "react-router-dom";
import ExperienceInputs from "../../../components/Experience/ExperienceInputs";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import NewsLetterInputs from "../../../components/NewsLetter/NewsLetterInput";
import CrisisPopupInput from "../../../components/CrisisPopupInput/CrisisPopupInput";

const CreateCrisisPopup = () => {
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Crisis Popup",
      route: "/website/cms/crisis-page/crisis-popup",
    },
    {
      title: "Add Crisis Popup",
      route: "/website/cms/crisis-page/crisis-popup/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"Crisis Popup"}>
      <CustomHeaderTitle title={"Create Crisis Popup"} />
      <HeaderBread
        navigation={navigation}
        title={"Add Crisis Popup"}
      ></HeaderBread>
      <CrisisPopupInput crisispopup={{}} />
    </Layout>
  );
};

export default CreateCrisisPopup;
